












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Connector from '@vue-polkadot/vue-api';
import ItemCard from '@/components/shared/wrapper/ItemCard.vue'
import Money from '@/components/shared/format/Money.vue'
import Percent from '@/components/shared/format/Percent.vue'
import WithLabel from '@/components/shared/format/WithLabel.vue'
import { AccountId } from '@polkadot/types/interfaces';
import { DeriveStakingQuery } from '@polkadot/api-derive/types';

const components = {
  ItemCard,
  Money,
  WithLabel,
  Percent
}

@Component({ components })
export default class ValidatorRow extends Vue {
  @Prop() public validator!: any;
  @Prop() public index!: number;

}
